<template>
<b-container>
    <h1>{{ $t("tracking.cargoExpenseOccurrence.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" /> 
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    
    <b-form @submit.prevent="save">
      <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBackToList">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
        </b-row>
      <b-row>
        <b-col>
          <cargo-expense-occurrence-crud-data
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            class="mb-4"
          >
          </cargo-expense-occurrence-crud-data>
        </b-col>
      </b-row>      
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <div>
      <!-- {{model}} -->
    </div>
   
</b-container>
</template>
<script>

export default {
  name: "CargoExpenseOccurrenceCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    CargoExpenseOccurrenceCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/cargoExpenseOccurrence/CargoExpenseOccurrenceCrudData.vue"
      ),
    
  },

  data() {
    return {
      alert: {
        error: "",
        success: "Ocorrência criada com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        sequenceNumber: 0,
        description : "",
        profiles: [],
        occurrenceTypeNext: [],
        customField: 0
      },
    };
  },
  created() {    
    this.loadAvailableProfiles();
    this.nextSequenceNumber();
  },
  computed: {
    getUrlBackToList() {
      return `/trackingShippingCompany/cargoExpenseOccurrence/list`;
    },
  },
  methods: {
    
    async nextSequenceNumber()
    {
      this.$api
      .get(`/v1/cargoExpense/occurrence/nextSequenceNumber`)
      .then((response) => {
        // console.log("entrou")
        // console.log(response.data);
        let model = response.data;
        this.model.sequenceNumber = model;
        this.model.description = " ";
        console.log(model.sequenceNumber)
      })
    },
    async loadAvailableProfiles()
    {
      this.$api
      .get(`/v1/cargoExpense/occurrence/availableProfiles`)
      .then((response) => {
        // console.log("entrou")
        // console.log(response.data);
        let model = response.data;
        this.model.profiles = model;
        console.log(model.profiles)
        window.scrollTo(0, 0);
      })
      .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
                window.scrollTo(0, 0);
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
            window.scrollTo(0, 0);
          }
        });
    },


  save() {
    this.submitted = true;
    
    this.$api
      .post("/v1/cargoExpense/occurrence/create", this.model)
      .then((response) => {
        this.nextSequenceNumber();
        this.loadAvailableProfiles();
        this.$refs.alert.show();
        this.modelstate = {};
        this.submitted = false;
      })
      .catch((error) => {
        this.submitted = false;
        this.modelstate = {};
        if (error.response) {
          console.log(error.response);
          if (error.response.status == 400) {
            console.log(error.response);
            console.log(error.response.data);
            console.log(error.response.data.errors);
            this.modelstate = error.response.data.errors;
            this.alert.error = "Verifique os dados informados";
          } else {
            if (error.response.data) {
              console.log(error.response.data);
              this.alert.error = `${error.response.status} - ${error.response.statusText} `;
            } else {
              this.alert.error = `${error.response.status} - ${error.response.statusText} `;
            }
          }
        } else {
          this.alert.error = error.message;
        }
        this.$refs.fadeAlertDanger.show();
      });
  },
  }
};
</script>
